<div class="mt-3" *ngFor="let beneficiaryType of beneficiaryTypes">
    <ng-container  *ngIf="!beneficiaryType.hidden">
        <app-basic-card>
            <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
                <h6>{{ beneficiaryType.title }}</h6>
            </div>
            <ng-container *ngFor="let beneficiary of beneficiaryType.list">
                <div class="pt-2">
                    <app-basic-card>
                        <div class="d-flex align-items-center vertical-align-middle justify-content-between">
                            <div class="d-flex align-items-center vertical-align-middle">
                                <mat-icon 
                                    class="user-icon" 
                                    aria-hidden="false" 
                                    aria-label="user-icon" 
                                    fontIcon="account_circle">
                                </mat-icon>
                                {{ getBeneficiaryDescription(beneficiary) }}
                            </div>
                            <div class="d-flex align-items-center vertical-align-middle justify-content-end">
                                <mat-icon *ngIf="canViewBeneficiary(beneficiary)"
                                    class="modify-icon" 
                                    aria-hidden="false" 
                                    aria-label="remove-icon" 
                                    fontIcon="visibility" 
                                    [matTooltip]="'Visualizza beneficiario'" 
                                    (click)="modifyBeneficiary(beneficiary)">
                                </mat-icon>
                                <mat-icon 
                                    class="remove-icon" 
                                    aria-hidden="false" 
                                    aria-label="remove-icon" 
                                    fontIcon="delete" 
                                    [matTooltip]="'Rimuovi beneficiario'" 
                                    (click)="removeBeneficiary(beneficiary)" 
                                    *ngIf="!isReadOnly">
                                </mat-icon>
                            </div>

                        </div>
                    </app-basic-card>
                </div>
            </ng-container>
            <mat-accordion *ngIf="beneficiaryType.type === 'M'">
                <div class="mt-3 mb-3">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>Dati del referente terzo</mat-panel-title>
                        </mat-expansion-panel-header>
                        <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>  
                        <app-basic-form [form]="thirdPartyRegistryForm" [keys]="thirdPartyRegistryFormKeys"></app-basic-form>      
                        <h6 class="card-header-label" style="padding: 1em;">Dati di recapito</h6>
                        <app-basic-form [form]="thirdPartyAddressForm" [keys]="thirdPartyAddressFormKeys"></app-basic-form>
                        <h6 class="card-header-label" style="padding: 1em;">Dati di contatto</h6>
                        <app-basic-form [form]="thirdPartyContactForm" [keys]="thirdPartyContactFormKeys"></app-basic-form>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
            <div class="mt-4 d-flex">
                <button 
                    mat-raised-button 
                    class="mx-3" 
                    color="primary" 
                    (click)="openNewBeneficiaryModal(beneficiaryType.type)" 
                    [disabled]="isReadOnly || beneficiaryType.list?.length > 4">
                {{ 'aggiungi beneficiario' | uppercase }}
                </button>
            </div>
        </app-basic-card>
    </ng-container>
</div>
